<template>
    <div class="form-group" :class="{'has-error': hasErrors, 'row': asRow}">
        <label
            v-if="label"
            :for="name"
            :class="labelClass">
            <span v-tooltip :title="title">
                {{ label }}

                <i v-if="required" class="fa fa-sm fa-fw fa-asterisk" />
                <i v-if="translatable" class="fa fa-sm fa-fw fa-flag text-primary" />
            </span>
        </label>

        <div :class="fieldClass">
            <slot />

            <ul v-show="hasErrors" class="form-error">
                <li v-for="(error, index) in errors" :key="index" class="text-danger">
                    {{ error }}
                </li>
            </ul>

            <slot name="tips" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormGroup',

    props: {
        name: {type: String, required: true},
        label: {type: String, default: null},
        required: {type: Boolean},
        translatable: {type: Boolean},

        errors: {type: Array, default: () => []},

        hideValidation: {type: Boolean},

        asRow: {type: Boolean},
        size: {
            type: String,
            default: null,
            validator: (value) => ['sm', 'lg'].indexOf(value) !== -1,
        },
    },

    computed: {
        title() {
            const parts = [];

            if (this.required) {
                parts.push(this.$t('common.fields.required'));
            }

            if (this.translatable) {
                parts.push(this.$t('common.fields.translatable'));
            }

            if (parts.length > 0) {
                return parts.join(' / ');
            }

            return undefined;
        },

        labelClass() {
            const sizeClass = this.size ? `col-form-label-${this.size}` : '';

            return this.asRow
                ? `col-sm-5 col-md-4 col-lg-3 col-form-label ${sizeClass}`
                : null;
        },

        fieldClass() {
            return this.asRow
                ? 'col-sm-7 col-xl-6'
                : null;
        },

        hasErrors() {
            return !this.hideValidation && (this.errors.length > 0);
        },
    },
};
</script>

<style scoped>
.fa-sm {
    font-size: 0.75em;
    line-height: 0.55em;
    top: -1px;
}

ul.form-error {
    list-style: none;
    padding: 0;
    margin: 5px 0 0 0;
}

ul.form-error > li {
    font-size: smaller;
}
</style>
